import {TooltipIconRA} from "@/components/overlay/TooltipIconRA.tsx";
import {LHRAudit} from "@/pages/pagespeed/types.ts";

import {getAuditDisplay} from "./lhrUtils";

interface UptimeCWVBlockProps {
  audits: Record<string, LHRAudit>;
}

export const UptimeCWVBlock = ({audits}: UptimeCWVBlockProps) => (
  <div className="bg-gray-100 rounded-3 p-3">
    <div className="d-flex mb-3">
      <div className="flex-grow-1">
        <strong>Core Web Vitals</strong>
      </div>
      <TooltipIconRA
        className="ms-2"
        title="Web Vitals are a concise set of essential metrics that serve as key indicators of the
              speed and overall user experience your website provides
              to visitors, commonly referred to as a “delightful” experience."
      />
    </div>
    <div className="d-flex align-items-center gap-10">
      <div className="metric flex-fill d-flex align-items-center">
        <div>
          <div className="label">LCP</div>
          <div className="value">{getAuditDisplay(audits, "largest-contentful-paint")}</div>
        </div>
      </div>
      <div className="metric flex-fill d-flex align-items-center">
        <div>
          <div className="label">TBT</div>
          <div className="value">{getAuditDisplay(audits, "total-blocking-time")}</div>
        </div>
      </div>
      <div className="metric flex-fill d-flex align-items-center">
        <div>
          <div className="label">CLS</div>
          <div className="value">{getAuditDisplay(audits, "cumulative-layout-shift")}</div>
        </div>
      </div>
    </div>
  </div>
);
